module.exports = global["$"] = require("-!/var/lib/jenkins/workspace/TEST2/webapp/node_modules/expose-loader/index.js?jQuery!/var/lib/jenkins/workspace/TEST2/webapp/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 26
// module chunks = 37